import { InitialPassword } from '@/features/auth';

const InitialPasswordPage = () => {
  return <InitialPassword />;
};

export default InitialPasswordPage;
